module.exports = __webpack_public_path__ + "img/controls-icon.174c33d9.svg";